import { useEffect } from "react";
import confetti from "canvas-confetti";

const ConfettiBlast = () => {
    useEffect(() => {
        const duration = 5000; // 8 seconds
        const animationEnd = Date.now() + duration;
        const defaults = {
            startVelocity: 45,
            spread: 300,
            ticks: 80,
            zIndex: 9999,
        };

        const randomInRange = (min: number, max: number) =>
            Math.random() * (max - min) + min;

        const interval = setInterval(() => {
            const timeLeft = animationEnd - Date.now();
            if (timeLeft <= 0) {
                clearInterval(interval);
                return;
            }

            // Fixed higher particle count for better visuals
            const particleCount = 70;

            confetti({
                ...defaults,
                particleCount,
                origin: {
                    x: randomInRange(0.1, 0.3),
                    y: randomInRange(0, 0.3),
                },
            });

            confetti({
                ...defaults,
                particleCount,
                origin: {
                    x: randomInRange(0.7, 0.9),
                    y: randomInRange(0, 0.3),
                },
            });
        }, 400); // Slower trigger rate for smoother output

        return () => clearInterval(interval);
    }, []);

    return null;
};

export default ConfettiBlast;
